import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import {withMapsAndDataProjectsMapLink} from '../utils/mapsAndDataNav';
import {withPartnerWithLadotNavLinks} from '../utils/getInvolvedPartnerForm';
//import {getMListNavById} from "../reducers/index";

//Action Creators
export const loadMListNavStart = (id) => {
  return {
    type: actionTypes.MLISTNAV_LOAD_START,
    id,
  };
};
export const loadMListNavFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MLISTNAV_LOAD_FAIL,
    id,
    error,
  };
};
export const loadMListNavSuccess = (data) => {
  return {
    type: actionTypes.MLISTNAV_LOAD_SUCCESS,
    data,
  };
};

export const initMListNavByCmsName = cmsName => dispatch => {
  dispatch(loadMListNavStart(cmsName));

  return apiActions
    .loadEndpointByFilters(apiValues.nref.mListNav.endpoint, {
      'filters[cmsName][$eq]': cmsName,
      'pagination[limit]': 1,
    })
    .then(results => {
      const result = Array.isArray(results) ? results[0] : results;
      if (!result) {
        return Promise.reject(new Error(`m-list-nav not found: ${cmsName}`));
      }
      return result;
    })
    .then(result => {
      const mListNav = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mListNav.fieldsUsed);
      mListNav.navigationLinks = apiActions.arraySelectCamelCaseKeys(
        mListNav.navigationLinks,
        apiValues.nref.navigationLink.fieldsUsed
      );
      const withNavFixes = withPartnerWithLadotNavLinks(
        withMapsAndDataProjectsMapLink(mListNav, cmsName),
      );
      dispatch(loadMListNavSuccess(withNavFixes));
      return withNavFixes;
    })
    .catch(error => dispatch(loadMListNavFail(cmsName, error)));
};

export const initMListNav = id => dispatch => {
  dispatch(loadMListNavStart(id));

  return apiActions.loadEndpoint(apiValues.nref.mListNav.endpoint, id).then(result => {
    let mListNav = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mListNav.fieldsUsed);
    mListNav.navigationLinks = apiActions.arraySelectCamelCaseKeys(mListNav.navigationLinks, apiValues.nref.navigationLink.fieldsUsed);
    const withNavFixes = withPartnerWithLadotNavLinks(withMapsAndDataProjectsMapLink(mListNav));
    dispatch(loadMListNavSuccess(withNavFixes));
    return withNavFixes;
  });
};


